import { createContext, useContext, type ComponentType } from "react";

/** How this environment signs admins in, provided to every /admin route by AdminAuthRoot. */
export interface AdminAuth {
  mode: "clerk" | "local" | "unconfigured";
  /** Clerk: whether there's a Clerk session. Local: not known until /api/auth/me answers (null). */
  signedIn: boolean | null;
  signOut: () => Promise<void>;
  /** Clerk's account screen: profile, email addresses, password, security. Clerk only. */
  manageAccount?: () => void;
  /** The sign-in and sign-up pages, when Clerk provides them (kept in the Clerk chunk, loaded only when used). */
  SignIn?: ComponentType;
  SignUp?: ComponentType;
  /** Why sign-in isn't available (unconfigured). */
  message?: string;
}

export const AuthContext = createContext<AdminAuth | null>(null);
export const useAdminAuth = () => useContext(AuthContext)!;

/** The sign-in page, coming back to `next` afterwards (`redirect_url` is also what Clerk reads). */
export const signInPath = (next = location.pathname + location.search) => `/admin/login?redirect_url=${encodeURIComponent(next)}`;

/** An admin page to return to after signing in. Anything else (another site, the sign-in page) goes to the dashboard. */
export const safeNext = (raw: string | null) => (raw && /^\/admin(\/|\?|$)/.test(raw) && !/^\/admin\/(login|sign-up)/.test(raw) ? raw : "/admin");
